exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-14-wrapper[data-v-395af810]{width:300px;padding-bottom:10px}.listing-img[data-v-395af810]{width:20px;height:20px;border-radius:50%}", ""]);

// exports
